import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../_services/auth.service';
import { AppComponent } from 'src/app/app.component';
import { NavService } from 'src/app/_services/nav.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'clasificacion-de-datos',
  templateUrl: './clasificacion-de-datos.component.html',
  styleUrls: ['./clasificacion-de-datos.component.css'],
})
export class ClasificacionDeDatosComponent implements OnInit {
  // tslint:disable-next-line: max-line-length
  constructor(
    private authService: AuthService,
    private appComponent: AppComponent,
    private navService: NavService,
    private translate: TranslateService
  ) {
    Window['appuser'] = this;
  }

  ngOnInit() {
    //this.authService.isAuthenticated();
    this.appComponent.setTitle('Data Clasification');
    this.authService.pageVisit().subscribe(
      () => {},
      (error) => {
        console.log(error);
      }
    );

    this.selectedNavItem({
      parent: 'microsoftPurview.microsoftPurview',
      child: 'dataClasification.dataClasification',
    });
  }

  selectedNavItem(data: any) {
    this.navService.emitNavChangeEvent(data);
  }
}
